import { createActionGroup, emptyProps, props } from '@ngrx/store';
import {
  Company,
  CompanyDetail,
  CompanyDetailPayload,
  CompanyOperatorUser,
  Currency,
} from '../models/company.model';
import { SupplierSettingsForm } from '../models/company-form.model';
import {
  SegmentParentOperation,
  SupplierSegmentation,
} from '../models/segment-parent.model';
import {
  BuyerConfigSettingsForm,
  BuyerConfigSettingsSavePayload,
  BuyerCountrySettingsSavePayload,
} from '../models/company-buyer-config.model';

export const CompanyActions = createActionGroup({
  source: 'Company',
  events: {
    'Set Search': props<{ search: string }>(),
    'Set Page': props<{ page: number }>(),
    'Reset State': emptyProps(),

    'Load Companies': props<{ limit?: number }>(),
    'Load Companies Success': props<{
      companies: Company[];
      count: number;
      page: number;
      cachedAt: number;
    }>(),
    'Load Companies Failure': props<{ error: string }>(),
    'Invalidate Cache': emptyProps(),

    'Load Currencies': emptyProps(),
    'Load Currencies Success': props<{ currencies: Currency[] }>(),
    'Load Currencies Failure': props<{ error: string }>(),

    'Select Company': props<{ id: number }>(),
    'Reload Detail': props<{ id: number }>(),
    'Load Detail Success': props<{ detail: CompanyDetail }>(),
    'Load Detail Failure': props<{ error: string }>(),
    'Clear Form': emptyProps(),

    'Start Create': emptyProps(),
    'Save Company': props<{ payload: CompanyDetailPayload }>(),
    'Save Company Success': props<{ id: number }>(),
    'Save Company Failure': props<{ error: string }>(),

    'Update Company': props<{ id: number; payload: CompanyDetailPayload }>(),
    'Update Company Success': emptyProps(),
    'Update Company Failure': props<{ error: string }>(),

    'Delete Company': props<{ id: number }>(),
    'Delete Company Success': emptyProps(),
    'Delete Company Failure': props<{ error: string }>(),

    'Load Supplier Settings': props<{ id: number }>(),
    'Load Supplier Settings Success': props<{
      settings: SupplierSettingsForm;
    }>(),
    'Load Supplier Settings Failure': props<{ error: string }>(),

    'Enable Segmentation': props<{ id: number }>(),
    'Enable Segmentation Success': props<{ id: number }>(),
    'Enable Segmentation Failure': props<{ error: string }>(),

    'Disable Segmentation': props<{ id: number }>(),
    'Disable Segmentation Success': props<{ id: number }>(),
    'Disable Segmentation Failure': props<{ error: string }>(),

    'Load Segment Parents': props<{ id: number }>(),
    'Load Segment Parents Success': props<{
      segmentation: SupplierSegmentation;
    }>(),
    'Load Segment Parents Failure': props<{ error: string }>(),

    'Save Segment Parents': props<{
      id: number;
      operations: SegmentParentOperation[];
    }>(),
    'Save Segment Parents Success': emptyProps(),
    'Save Segment Parents Failure': props<{ error: string }>(),

    'Save Supplier Settings': props<{
      id: number;
      settings: SupplierSettingsForm;
    }>(),
    'Save Supplier Settings Success': emptyProps(),
    'Save Supplier Settings Failure': props<{ error: string }>(),

    'Load Operator Users': emptyProps(),
    'Load Operator Users Success': props<{
      operatorUsers: CompanyOperatorUser[];
    }>(),
    'Load Operator Users Failure': props<{ error: string }>(),

    'Load Buyer Config Settings': props<{ id: number }>(),
    'Load Buyer Config Settings Success': props<{
      settings: BuyerConfigSettingsForm;
    }>(),
    'Load Buyer Config Settings Failure': props<{ error: string }>(),

    'Save Buyer Config Settings': props<{
      payload: BuyerConfigSettingsSavePayload;
    }>(),
    'Save Buyer Config Settings Success': emptyProps(),
    'Save Buyer Config Settings Failure': props<{ error: string }>(),

    'Save Buyer Country Settings': props<{
      payload: BuyerCountrySettingsSavePayload;
    }>(),
    'Save Buyer Country Settings Success': emptyProps(),
    'Save Buyer Country Settings Failure': props<{ error: string }>(),

    'Reset Buyer Config Settings': props<{ id: number }>(),
    'Reset Buyer Config Settings Success': props<{
      id: number;
      message: string;
    }>(),
    'Reset Buyer Config Settings Failure': props<{ error: string }>(),

    'Register Webhook': props<{ buyerId: number; webhook: string }>(),
    'Register Webhook Success': emptyProps(),
    'Register Webhook Failure': props<{ error: string }>(),

    'Unsubscribe Webhook': props<{ buyerId: number }>(),
    'Unsubscribe Webhook Success': emptyProps(),
    'Unsubscribe Webhook Failure': props<{ error: string }>(),
  },
});
